import { Box, Typography } from '@mui/material';
import { DpContainer } from '@/components/blocks/DpContainer';
import {
	sectionChipSX,
	sectionEyebrowSX,
	sectionHeaderSX,
	sectionHeaderTextSX,
	sectionSubtitleSX,
	sectionTitleSX,
} from '@/components/blocks/DpRepurchaseCoupon/styles/section';

type Props = {
	anchor?: string;
	eyebrow?: string;
	title: string;
	subtitle?: string;
	chip?: string;
};

export const RepurchaseSectionHeader = ({ anchor, eyebrow, title, subtitle, chip }: Props) => (
	<DpContainer withoutmargin>
		<Box component="header" id={anchor || undefined} sx={sectionHeaderSX}>
			<Box sx={sectionHeaderTextSX}>
				{eyebrow ? (
					<Typography component="p" sx={sectionEyebrowSX}>
						{eyebrow}
					</Typography>
				) : null}
				<Typography component="h2" sx={sectionTitleSX}>
					{title}
				</Typography>
				{subtitle ? (
					<Typography component="p" sx={sectionSubtitleSX}>
						{subtitle}
					</Typography>
				) : null}
			</Box>
			{chip ? (
				<Typography component="span" sx={sectionChipSX}>
					{chip}
				</Typography>
			) : null}
		</Box>
	</DpContainer>
);
